import { render, staticRenderFns } from "./Retenciones.vue?vue&type=template&id=00200cef&scoped=true&lang=pug"
import script from "./Retenciones.vue?vue&type=script&lang=js"
export * from "./Retenciones.vue?vue&type=script&lang=js"
import style0 from "./Retenciones.vue?vue&type=style&index=0&id=00200cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00200cef",
  null
  
)

export default component.exports